import {useContext, useEffect} from 'react';
import { Spin } from 'antd';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import LoadingContext from './contexts/LoadingContext';
import {appRoutes, authRoutes, redirectAuth} from "./routes/web";
import Authenticate from "./middleware/Authenticate";
import Profile from "./pages/user/Profile";
import Security from "./pages/user/Security";
import ErrorNotFound from "./pages/error/ErrorNotFound";
import authService from './services/authService';

function App() {
    const { loading } = useContext(LoadingContext);
    useEffect(() => {
        document.title = process.env.REACT_APP_TITLE || 'React App';
        // Khởi tạo auth service
        authService.init();
    }, []);
    return ( 
        <BrowserRouter>
            <Spin size='large' fullscreen={true} spinning={loading}/>
            <Routes>
                {authRoutes.map((value,index) => {
                    return <Route key={index} path={value.path} element={value.element}/>
                })}
                {appRoutes.map((value, index) => {
                    if (value.type === 'item') {
                        return <Route key={index} path={value.path} element={<Authenticate>{value.element}</Authenticate>}/>
                    } else if (value.type === 'children') {
                        const children =  value.children;
                        return children.map((item, indexChildren) => {
                            return <Route key={index + '-' + indexChildren} path={item.path} element={<Authenticate>{item.element}</Authenticate>}/>
                        })
                    }
                })}
                <Route path={'/user/profile'} element={<Authenticate><Profile/></Authenticate>}/>
                <Route path={'/user/security'} element={<Authenticate><Security/></Authenticate>}/>
                <Route path={'*'} element={<ErrorNotFound/>}/>
            </Routes>
        </BrowserRouter>
    );
}

export default App;
